
<t4-container title="{{ 'Turbo.Campaign.FindCampaignDialog.Headline' | translate : 'Find campaign or voucher' }}" style="min-width: 1200px; ">
  <div style="width: 100%;" class="turboContainer">
    <mat-form-field style="width: 100%; min-width:1200px;">
      <input matInput [formControl]="txtKeywords" placeholder="{{'Turbo.Campaign.FindCampaignDialog.txtKeywords' | translate : 'Enter discount code'}}" />
    </mat-form-field>
  </div>
</t4-container>
<br/>
<t4-container style="min-width: 1200px;">
    <div *ngIf="!campigns">{{'Turbo.Campaign.FindCampiagnsDialog.msgNoCampaigns' | translate : 'No campaigns has been found'}}</div>
    <div *ngIf="campigns" style="height: 250px; overflow: auto;">
      <div *ngFor="let item of campigns" class="list-item" (click)="showCampaign(item.DiscountCode)">
        <div class="col-xs-2" style="text-align: left"><b>{{item.DiscountCode}}</b></div>
        <div class="col-xs-3" style="text-align: left">{{item.ValidFrom | date : 'yyyy-MM-dd'}}<mat-icon>horizontal_rule</mat-icon>{{item.ValidThrough | date : 'yyyy-MM-dd'}}</div>
        <ng-container *ngIf="item.ValueType == 1"> {{ item.Value | currency }}</ng-container>
        <ng-container *ngIf="item.ValueType == 0"> {{ item.Value/100.00 | percent}}</ng-container>
        <div class="row col-xs-3" style="text-align: right">
          <div>{{item.Comment}}</div>
          <div style="margin-left:45px;">{{item.ConditionText}}</div>
        </div>
      </div>
    <div class="loader" *ngIf="loading.dialog">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading.dialog"></mat-progress-bar>
    </div>
  </div>
</t4-container>
